import axios from 'axios'
import axiosRetry from 'axios-retry'

function apiOrigin() {
  if (import.meta.env.DEV) {
    return typeof window === 'undefined' ? '' : window.location.origin
  }
  try {
    return new URL(import.meta.env.VITE_BASE_URL).origin
  } catch {
    return typeof window === 'undefined' ? '' : window.location.origin
  }
}

function pageOrigin() {
  return typeof window === 'undefined' ? '' : window.location.origin
}

const myAxios = axios.create({
  // A partner page calls the main API host. Cookies stay on that host;
  // the page sends x-auth instead, so the request must not be credentialed.
  withCredentials: pageOrigin() !== '' && pageOrigin() === apiOrigin(),
  // Vite dev proxies API paths to the backend so cookie auth stays
  // same-origin. Production/stage keep the explicit API origin.
  baseURL: import.meta.env.DEV ? '' : import.meta.env.VITE_BASE_URL,
})
axiosRetry(myAxios, {
  retries: 3, // Number of retries
  retryDelay: retryCount => {
    return Math.pow(2, retryCount) * 2000
  },
  // retryCondition: error => {
  //   // Only retry if it's a network error or a 5xx status code
  //   // AND NOT a 401 Unauthorized error
  //   return (
  //     (axiosRetry.isNetworkError(error) ||
  //       (error.response &&
  //         error.response.status >= 500 &&
  //         error.response.status <= 599)) &&
  //     error.response?.status !== 401
  //   )
  // },
  // attach callback to each retry to handle logging or tracking
  onRetry: err => console.log(`Retrying request: ${err.message}`),
  // Specify conditions to retry on, this is the default
  // which will retry on network errors or idempotent requests (5xx)
  retryCondition: error => {
    const status = error.response?.status
    // Retry only if status is NOT 401 and it meets the default retry condition
    return (
      ![401, 403].includes(status) &&
      axiosRetry.isNetworkOrIdempotentRequestError(error)
    )
  },
})

myAxios.interceptors.response.use(
  function (response) {
    return response
  },
  async function (error) {
    console.error(error)
    return Promise.reject(error)
  }
)
// Add a request interceptor
myAxios.interceptors.request.use(function (config) {
  if (isApiRequest(config.url)) {
    const token = window.sessionStorage.getItem('user')
    if (token) {
      config.headers['x-auth'] = token
    }
  }
  return config
})

function isApiRequest(url) {
  if (typeof url !== 'string' || !url) return false
  if (!/^https?:\/\//i.test(url)) return true
  try {
    return new URL(url).origin === apiOrigin()
  } catch {
    return false
  }
}

export default myAxios
